export default __webpack_public_path__ + "static/media/05.a43ac423.png";